import config from '../data/config.json';
import dict from '../data/dictionary.json';
import { cardTemplate, layerGroupTemplate } from '../data/htmlTemplates.js';

import Mustache from 'mustache';
import bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import L from 'leaflet';
import { LocateControl } from "leaflet.locatecontrol";
import "leaflet.locatecontrol/dist/L.Control.Locate.min.css";
import "leaflet-draw/dist/leaflet.draw.css";
import 'leaflet-draw';


import { Sesion, Datos, Layers, obtenerURL, cargarURL } from '../main.js';
import { Mimapa, mapaMovido, actualizarMapaBase } from './map.js';
import { handlerFiltrarTaxon, handlerNombreCientifico, visualizarFiltrosTaxon, handlerAjustarFiltroTaxon,
	correspondenciaTaxon, correspondenciaTaxonMulti } from './taxons.js';
import { renderEntradaLugares, obtenerSugerenciasLugares, renderSugerenciasLugares, ajustarLugarfocus } from './places.js';
import { ajustarPopupsProvincias, quitarProvincias } from './provinces.js';
import { ajustarPopupsTeselas, quitarTeselas } from './patches.js';
import { ajustarPopupsParcelas, quitarParcelas } from './plots.js';
import { ajustarPopupsArboles, quitarArboles } from './trees.js';
import { lanzarTour } from './shepherd.js';
import { prepararDescarga } from './download.js';
import { getLiteral } from './util.js';
import { sendEvent } from './events.js';

let drawControl;

// PANEL DE CONTROL
function cargarPanel() {
	//  panel de control de info
	let panelInfo = L.control({'position':'topleft'});
	panelInfo.onAdd = function (map) {
		// creo div con clase "card" de bootstrap
		this._div = L.DomUtil.create('div', 'card ms-1 ms-sm-2 mt-1 mt-sm-2 panel-control');	// versión 5.3 bootstrap
		return this._div;
	};
	panelInfo.init = function () {
		// inicializo el panel con el nombre científico
		const obj = {
			nomci: Sesion.nomci,
			noplots: !Sesion.estado.plots,
			plantaeUnset: !Sesion.taxonesFiltros[config.treeUri]
		};
		const cardhtml = Mustache.render(cardTemplate, obj);
		document.querySelector(".panel-control").innerHTML = cardhtml;
		
		// handler del radio con la versión del ifn
		document.querySelectorAll('input[type=radio][name=ifnradio]').forEach(function(radio) {
			radio.addEventListener('change', function() {
    			// guardo el valor del ifn
				Sesion.estado.ifn = this.getAttribute('id');
				// borro contenido de "#taxones_block" ya que la taxonomía cambiará según la versión del IFN
				// (se regenerará el contenido al pulsar el botón de taxón)
				document.getElementById("taxones_block").innerHTML = "";
			 			
				// selección edición ifn
				sendEvent( 'select_content', { content_type: 'edition_' + Sesion.estado.ifn } );
			
			 	// reinicio taxones (con las agrupaciones del IFN2 podría quedarme con menos filtros)
			 	const taxonesnew = [];
			 	const taxonesCorrExpurisnew = [];
			 	for (const tx of Sesion.taxones) {
			 		const txmap = correspondenciaTaxon(tx, Sesion.estado.ifn);
			 		// sólo lo incluyo si no estaba
			 		if (!taxonesnew.includes(txmap)) {			 		
				 		taxonesnew.push(txmap);
				 		taxonesCorrExpurisnew.push( correspondenciaTaxonMulti(Datos.taxones[txmap].expuris, "ifn3") );
			 		}
			 		// además, reemplazo lo que hubiera en el filtro de taxón de un ifn a otro
			 		if (Sesion.taxonesFiltros[tx]) {
			 			if (!Sesion.taxonesFiltros[txmap]) // no reescribo varias veces
				 			Sesion.taxonesFiltros[txmap] = Sesion.taxonesFiltros[tx];
			 			delete Sesion.taxonesFiltros[tx];
			 		}
			 	}
			 	Sesion.taxones = taxonesnew;
			 	Sesion.taxonesCorrExpuri = taxonesCorrExpurisnew;
			 	
				 // reajusto URL
				history.replaceState(Sesion.estado, "", obtenerURL());
			 
				// actualizo filtros de taxón (para mapeos de taxones)
				visualizarFiltrosTaxon();
				// quito las provincias
				quitarProvincias();
				// quito las parcelas
				quitarParcelas();
				// llamo a actualizar el mapa
				mapaMovido();
			});
		});
		
		// handler del nombre científico
		document.querySelector('.nomci').addEventListener('change', handlerNombreCientifico);
		
		// handler de taxón
		document.getElementById('bot_taxones').addEventListener('click', handlerFiltrarTaxon);
		
		// handler ajustar_filtro plantae
		document.getElementById('filter-plantae').addEventListener('click', handlerAjustarFiltroTaxon);
		
		// handler del botón de buscar lugares
		document.getElementById('in_bot_lugares').addEventListener('change', function() {
			renderEntradaLugares(true);
		});
		
		// detecto cambios en la entrada de lugares
		// "search" es para detectar si el usuario hizo click en la X del formulario (clear button)
		document.getElementById("in_lugares").addEventListener("keyup", async function(e) {
			handleInputEvent(e);
		});
		document.getElementById("in_lugares").addEventListener("search", async function(e) {
			handleInputEvent(e);
		});
		async function handleInputEvent(e) {
			// primero recupero la entrada
			const entrada = document.getElementById("in_lugares").value;
			// trato las teclas de arriba, abajo y enter			
			if (e.which === 13) { // ENTER key
					// sólo actúo si hay al menos una sugerencia (y habilitada)
				if (Array.from(document.getElementById("sugelugares").children).filter(child => !child.disabled).length > 0) {
					// si no había ninguna sugerencia seleccionada activo la primera
					if (Sesion.lugarfocus === -1) {
						Sesion.lugarfocus = 0;
						ajustarLugarfocus();
					}
						// y ahora vamos al lugar seleccionado
					Array.from(document.getElementById("sugelugares").children).filter(child => !child.disabled)[Sesion.lugarfocus].click();
				}
			} else if (e.which === 40) { // DOWN arrow key
				// incremento focus
				Sesion.lugarfocus++;
				ajustarLugarfocus();
			} else if (e.which === 38) { // UP arrow key
				// decremento focus
				Sesion.lugarfocus--;
				ajustarLugarfocus();
			} else if (e.which !== undefined) { // Normal case
				// si había marcador de municipio, lo quito
				if (Sesion.lugarmarker) {
					Sesion.lugarmarker.remove();
					Sesion.lugarmarker = null;
					Sesion.lugar = null;
				}
				// actúo según la entrada
				if (entrada.length === 0) { // No input
					document.getElementById("sugelugares").innerHTML = "";
					document.getElementById("sugelugares").classList.add("d-none");
				} else { // obtengo sugerencias y hago su render
					document.getElementById("sugelugares").classList.remove("d-none");
					const sugs = await obtenerSugerenciasLugares(entrada);
					renderSugerenciasLugares(sugs);
				}
			} else {
				// caso de la X del formulario... (quito las sugerencias y el marcador si lo hay)
				if (entrada.length === 0) { // No input
					document.getElementById("sugelugares").innerHTML = "";
					document.getElementById("sugelugares").classList.add("d-none");
					if (Sesion.lugarmarker !== null) {
						Sesion.lugarmarker.remove();
						Sesion.lugarmarker = null;
						Sesion.lugar = null;
					}
				}
			}
		}
		// Handle focusin event
		document.getElementById("in_lugares").addEventListener("focusin", function() {
			// vuelve el focus, muestro las sugerencias si hay algo
			const entrada = document.getElementById("in_lugares").value;
			if (entrada.length > 0) 
				document.getElementById("sugelugares").classList.remove("d-none");
		});
		// Handle focusout event
		document.getElementById("in_lugares").addEventListener("focusout", function() {
			// si pierde el focus escondemos las sugerencias tras un delay
			// el delay es importante para que se pueda clickar un botón antes de eliminar las sugerencias
			setTimeout(function() {
				if (!document.getElementById("in_lugares").matches(":focus")) // si vuelve el focus no escondo
					document.getElementById("sugelugares").classList.add("d-none");
			}, 300);
		});
	};
	
	// incluyo el panel en el mapa
	panelInfo.addTo(Mimapa);
		    
    // si es terminal táctil desactivo los eventos de dragging del mapa en el panel del formulario
    if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
    	panelInfo.getContainer().addEventListener('touchstart', function () {
    		Mimapa.dragging.disable();
    	}); 
    	panelInfo.getContainer().addEventListener('touchend', function () {
    		Mimapa.dragging.enable();
    	});
    } else { // para terminales no táctiles desactivo los listeners del mapa al entrar en el panel del formulario
    	// Disable dragging, scrollWheelZoom and doubleClickZoom when user's cursor enters the element
		panelInfo.getContainer().addEventListener('mouseover', function () {
			Mimapa.dragging.disable();
			Mimapa.scrollWheelZoom.disable();
			//Mimapa.doubleClickZoom.disable();
		});
		// Re-enable dragging, scrollWheelZoom and doubleClickZoom when user's cursor leaves the element
		panelInfo.getContainer().addEventListener('mouseout', function () {
			Mimapa.dragging.enable();
			Mimapa.scrollWheelZoom.enable();
			//Mimapa.doubleClickZoom.enable();
		});
    }
	
	// inicializo panel
	panelInfo.init();
}


// BOTONES LATERALES MAPA
function cargarBotonesMapa() {	
	// BOTÓN DE MI LOCALIZACIÓN CON Leaflet.Locate (ver https://github.com/domoritz/leaflet-locatecontrol)
	//L.control.locate({
	new LocateControl({
	    position: 'bottomright',
	    icon: 'bi bi-geo-fill',
		locateOptions: { animate: true, duration: 1 },
		initialZoomLevel: config.zCambioRadio,
	    flyTo: true,
	    showPopup: false,
	    drawCircle: false,
	    showCompass: true,
    	strings: {
        	title: getLiteral(dict.mylocation)
	    }
	}).addTo(Mimapa);
	// cambio estilo del control de mi posición y mando evento de activate_my_location o deactivate_my_location a GA
	Mimapa.on("locateactivate", function(e) {
		// estilo botón en modo edición
		document.querySelector(".leaflet-control-locate a").style.backgroundColor = "#6c757d";
		document.querySelector(".leaflet-control-locate a span").style.color = "white";
		sendEvent( 'select_content', { content_type: 'activate_my_location' } );
	});	
	Mimapa.on("locatedeactivate", function(e) {
		// estilo botón normal
		document.querySelector(".leaflet-control-locate a").style.backgroundColor = "";
		document.querySelector(".leaflet-control-locate a span").style.color = "";
		sendEvent( 'select_content', { content_type: 'deactivate_my_location' } );
	});
	
	
	// BOTÓN TOUR
	const controlTour = L.Control.extend({
		options: {
			position: 'bottomright'
		},
		onAdd: function (map) {
			// preparo contenedor para el control del tour
			const container = L.DomUtil.create('div', "leaflet-bar leaflet-control div-tour");
			
			// link tour
			const lt = L.DomUtil.create("a", "leaflet-bar-part leaflet-bar-part-single tour", container);
			lt.title = getLiteral(dict.tour);
			lt.href = "#";
			lt.setAttribute("role", "button");
			L.DomUtil.create('span', 'bi bi-question-lg', lt);
			
			// listener tour
			lt.addEventListener('click', function(e) {
				e.preventDefault(); // Prevent the default behavior of the hyperlink
				lanzarTour();		
			});
			
			return container;
		}
	});		
	// instancio el control
	const cbt = new controlTour();
	// incluyo el control en el mapa
	Mimapa.addControl(cbt);

	// BOTÓN DESCARGA con Leaflet Draw
	Layers.editableLayer = new L.FeatureGroup();
	Mimapa.addLayer(Layers.editableLayer);    
	const ldo = {
		position: 'bottomright',
		draw: {
			polyline: false,
			polygon: {
				allowIntersection: false, // Restricts shapes to simple polygons
				drawError: {
					//color: '#e1e100', // Color the shape will turn when intersects
					message: getLiteral(dict.errorPolygon)
				},
				shapeOptions: {
					//color: '#bada55'
				}
			},
			circle: false, // Turns off this drawing tool
			rectangle: false,
			marker: false,
			circlemarker: false
		},
		edit: false
	};    
	drawControl = new L.Control.Draw(ldo);
	Mimapa.addControl(drawControl);
	Mimapa.on(L.Draw.Event.CREATED, function (e) {
		// actualizo flag
		Sesion.poligonero = false;
		// actualizo aspecto botón (sin pulsar)
		document.querySelector(".download").removeAttribute("style");
		document.querySelector(".download span").removeAttribute("style");
		// añado el polígono a la capa editable
		Layers.editableLayer.addLayer(e.layer);		
		// desde aquí llamo a la descarga de datos
		prepararDescarga();
	});
	// cambio icono polígono
	document.querySelector(".leaflet-draw-draw-polygon").innerHTML = '<span class="bi bi-cloud-download-fill"></span>';
	// añado clase inicial "download"
	document.querySelector(".leaflet-draw-draw-polygon").classList.add("download");
	// llamo a actualizar las etiquetas de Leaflet Draw
	actualizarEtiquetasLDraw();
	// listener botón
	document.querySelector(".download").addEventListener('click', function(e) {
		// cojo ref al botón de cancelar
		//let cancelAnchor = $('ul.leaflet-draw-actions').find('li:eq(2) a');	
		let cancelAnchor = document.querySelector('ul.leaflet-draw-actions').querySelector('li:nth-child(3) a');
		// cambio el flag de poligonero
		Sesion.poligonero = !Sesion.poligonero;	
		if (Sesion.poligonero) {
			// muestro tostada
			document.getElementById('mitostadaBody').innerHTML = getLiteral(dict.downloadPolygonToast);
			const tostada = bootstrap.Toast.getOrCreateInstance(document.getElementById('mitostada'));
			tostada.show();
			// actualizo aspecto botón (pulsado)
			document.querySelector(".download").setAttribute("style", "background-color: #6c757d;");
			document.querySelector(".download span").setAttribute("style", "color: white;");
			// pongo listener para que quede bien el flag de poligonero
			cancelAnchor.addEventListener('click', function(event) {
				Sesion.poligonero = false;
				// actualizo aspecto botón (sin pulsar)
        		document.querySelector(".download").removeAttribute("style");
    			document.querySelector(".download span").removeAttribute("style");
    		});
		}
		else  // llamo a cancelar
			cancelAnchor.click();
	});
	
	
	// BOTÓN CAPAS DEL MAPA
	const controlBotonLayers = L.Control.extend({
		options: {
			position: 'bottomright'
		},
		onAdd: function (map) {
			// preparo contenedor para el control de las capas
			const container = L.DomUtil.create('div', "leaflet-bar leaflet-control btn-toolbar div-layers");
			container.setAttribute("role", "toolbar");
			return container;
		}
	});
	// instancio el control
	const cbl = new controlBotonLayers();
	// incluyo el control en el mapa
	Mimapa.addControl(cbl);
    // si es terminal táctil desactivo los eventos de dragging del mapa en el panel del formulario
    if (('ontouchstart' in window) || (navigator.MaxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
    	document.querySelector('.div-layers').addEventListener('touchstart', function () {
    		Mimapa.dragging.disable();
    	}); 
    	document.querySelector('.div-layers').addEventListener('touchend', function () {
    		Mimapa.dragging.enable();
    	});
    } else { // para terminales no táctiles desactivo los listeners del mapa al entrar en el panel del formulario
    	// Disable dragging, scrollWheelZoom and doubleClickZoom when user's cursor enters the element
    	document.querySelector('.div-layers').addEventListener('mouseover', function () {
			Mimapa.dragging.disable();
			Mimapa.scrollWheelZoom.disable();
			//Mimapa.doubleClickZoom.disable();
		});
		// Re-enable dragging, scrollWheelZoom and doubleClickZoom when user's cursor leaves the element
		document.querySelector('.div-layers').addEventListener('mouseout', function () {
			Mimapa.dragging.enable();
			Mimapa.scrollWheelZoom.enable();
			//Mimapa.doubleClickZoom.enable();
		});
    }	
	// incluyo el contenido boton layers
	incluirContenidoBotonLayers();
}

// CAPAS DEL MAPA
function incluirContenidoBotonLayers() {	
	// añado el contenido al control
	document.querySelector(".div-layers").innerHTML = layerGroupTemplate;
	// quito borde
	document.querySelector(".div-layers").style.border = "none";
	// pongo los checks
	document.getElementById('map-type-' + Sesion.estado.mapType).checked = true;
	document.getElementById('map-details-' + Sesion.estado.mapDetails).checked = true;
	if (Sesion.estado.plots)
		document.getElementById('check-plots').checked = true;
	
	// si se abre el collapsible pongo un handler para que lo cierre si se clicka en el mapa
	const myCollapsible = document.getElementById('sel-layers');	
	myCollapsible.addEventListener('shown.bs.collapse', event => {
		document.getElementById('mimapa').addEventListener('click', handlerCerrarLayerCollapsible);
		// actualizo aspecto botón (pulsado)
		document.querySelector(".layer").style.backgroundColor = "#6c757d";
		document.querySelector(".layer span").style.color = "white";
	});
	
	// pongo listener a los cambios en la capa
	document.querySelectorAll('input[name="mapType"]').forEach(input => {
		input.addEventListener('change', handleLayerChange);
	});
	document.querySelectorAll('input[name="mapDetails"]').forEach(input => {
		input.addEventListener('change', handleLayerChange);
	});
	document.getElementById('check-plots').addEventListener('change', handleLayerChange);
}
function handlerCerrarLayerCollapsible(event) {
    if (!event.target.closest('#sel-layers')) {
        // quito este handler
		document.getElementById('mimapa').removeEventListener('click', handlerCerrarLayerCollapsible);
        // cierro el collapsible
        document.querySelector('.layer').click();
		// actualizo aspecto botón (sin pulsar)
        document.querySelector('.layer').style.backgroundColor = "";
        document.querySelector('.layer span').style.color = "";
    }
}
function handleLayerChange() {	
	// recupero valores
	const newPlots = document.getElementById('check-plots').checked;
	const newMapDetails = document.querySelector('input[name="mapDetails"]:checked').value;
	const newMapType = document.querySelector('input[name="mapType"]:checked').value;
	
	// detecto cambios y actúo
	if (newPlots !== Sesion.estado.plots) {
		Sesion.estado.plots = newPlots;
		sendEvent( 'select_content', { content_type: 'check_plots_' + Sesion.estado.plots } );
		// muestro/escondo botones de filtrar taxón por parcela		
		document.querySelectorAll('#filter-plantae, .tune_filter_taxon').forEach(el => {
			if (Sesion.estado.plots)
				el.classList.remove('d-none');
			else
				el.classList.add('d-none');
		});
	}
	if (newMapDetails !== Sesion.estado.mapDetails) {
		Sesion.estado.mapDetails = newMapDetails;
		sendEvent( 'select_content', { content_type: 'map_details_' + Sesion.estado.mapDetails } );		
	}	
	if (newMapType !== Sesion.estado.mapType) {
		Sesion.estado.mapType = newMapType;
		sendEvent( 'select_content', { content_type: 'map_type_' + Sesion.estado.mapType } );	
		// llamo a actualizar el mapa base
		actualizarMapaBase();
		// quito las provincias para que las repinte con el nuevo estilo
		quitarProvincias();
		// quito las teselas para que las repinte con el nuevo estilo
		quitarTeselas();
		// quito los árboles para que repinte sus parcelas con el nuevo estilo
		quitarArboles();	
	}
    
	// actualizo URL
	history.replaceState(Sesion.estado, "", obtenerURL());	
	// y llamo a mapaMovido para que actualice el mapa
	mapaMovido();
}


// IDIOMA
function actualizarIdiomaPanel() {
	// actualizo título de la página si hace falta
	if (Sesion.estado.path === "map")
		document.title = getLiteral(dict.map) + ' - ' + getLiteral(dict.title);
	// actualizo etiquetas panel mapa
	document.getElementById('bot_inicio').setAttribute("title", getLiteral(dict.menu));
	document.getElementById('tarjeta-home').innerHTML = getLiteral(dict.ttHome);
	document.getElementById('bot_taxones').innerHTML = getLiteral(dict.taxonfilter);
	document.getElementById('lab_bot_lugares').setAttribute("title", getLiteral(dict.searchplace));
	document.getElementById('bot_mapnomci').setAttribute("title", getLiteral(dict.nomci));
	document.getElementById('in_lugares').setAttribute("placeholder", getLiteral(dict.searchplace));
	document.getElementById('in_lugares').setAttribute("aria-label", getLiteral(dict.searchplace));
	document.getElementById('mibarra_loading').innerHTML = getLiteral(dict.loadingdata);
	document.querySelector('.ifnradio').setAttribute("title", getLiteral(dict.ifnversion));
	document.querySelector('.ifnradio').setAttribute("aria-label", getLiteral(dict.ifnversion));
	document.getElementById('label-ifn2').innerHTML = getLiteral(dict.IFN2);
	document.getElementById('label-ifn3').innerHTML = getLiteral(dict.IFN3);
	document.getElementById('label-ifn4').innerHTML = getLiteral(dict.IFN4);
	document.querySelector('.leaflet-control-locate a').setAttribute("title", getLiteral(dict.mylocation));
	if (document.querySelector('.leaflet-control-zoom-in'))
		document.querySelector('.leaflet-control-zoom-in').setAttribute("title", getLiteral(dict.zoomin));
	if (document.querySelector('.leaflet-control-zoom-out'))
		document.querySelector('.leaflet-control-zoom-out').setAttribute("title", getLiteral(dict.zoomout));
	
	// cierro bot_taxones e inicializo a "" el navegador de taxones
	if (document.getElementById('bot_taxones').classList.contains('active')) 
		document.getElementById('bot_taxones').click();
	document.getElementById('taxones_block').innerHTML = "";
	document.getElementById('taxones_block').classList.add('d-none');	

	// regenero nombres filtros de taxón	
	visualizarFiltrosTaxon();
	
	// regenero contenidos botón layers
	incluirContenidoBotonLayers();
	
	// actualizamos etiquetas Leaflet Draw
	actualizarEtiquetasLDraw();
	
	// regeneramos los popups de las provincias
	ajustarPopupsProvincias();
	
	// regeneramos los popups de las teselas
	ajustarPopupsTeselas(Object.keys(Sesion.tesPintadas), true);
	
	// regeneramos los popups de las parcelas
	ajustarPopupsParcelas(Object.keys(Sesion.parPintadas));
	
	// regeneramos los popups de los árboles
	ajustarPopupsArboles(Object.keys(Sesion.parcarbPintadas));
}

// etiquetas Leaflet.Draw
function actualizarEtiquetasLDraw() {
	document.querySelector(".leaflet-draw-draw-polygon").setAttribute("title", getLiteral(dict.downloadData));
	L.drawLocal.draw.toolbar.actions.text = getLiteral(dict.cancel);
	L.drawLocal.draw.toolbar.actions.title = getLiteral(dict.cancelPolygon);
	L.drawLocal.draw.toolbar.finish.text = getLiteral(dict.finish);
	L.drawLocal.draw.toolbar.finish.title = getLiteral(dict.finishPolygon);
	L.drawLocal.draw.toolbar.undo.text = getLiteral(dict.deleteLastPoint);
	L.drawLocal.draw.toolbar.undo.title = getLiteral(dict.deleteLastPointDrawn);
	L.drawLocal.draw.toolbar.buttons.polygon = getLiteral(dict.downloadData);
	L.drawLocal.draw.handlers.polygon.tooltip.start = getLiteral(dict.startPolygon);
	L.drawLocal.draw.handlers.polygon.tooltip.cont = getLiteral(dict.contPolygon);
	L.drawLocal.draw.handlers.polygon.tooltip.end = getLiteral(dict.endPolygon);
	L.drawLocal.draw.handlers.polyline.error = getLiteral(dict.errorPolygon);
	drawControl.options.draw.polygon.drawError.message = getLiteral(dict.errorPolygon);
}

export { cargarPanel, cargarBotonesMapa, actualizarIdiomaPanel };